import styled from '@emotion/styled';

const UserInfoWrapper = styled('div')({
  marginLeft: '5rem',
  marginTop: '5rem',
});

export default UserInfoWrapper;
